import type { Option } from "../../../../../components/general/Dropdown.tsx";
import { ClientReport } from "./models.ts";

export enum ClientFilter {
    All = 'ALL',
    NoBankConnection = 'NO_BANK_CONNECTION',
}

export const CLIENT_FILTER_OPTIONS: Option[] = [
    { value: ClientFilter.All, label: 'Alle klanten' },
    { value: ClientFilter.NoBankConnection, label: 'Geen bankkoppeling' },
];

export function filterClientRows<T extends Pick<ClientReport, 'has_bank_connection'>>(rows: T[], filter: ClientFilter): T[] {
    switch (filter) {
        case ClientFilter.All:
            return rows;
        case ClientFilter.NoBankConnection:
            return rows.filter((row) => !row.has_bank_connection);
    }
}
